<template>
  <div
    v-if="outfitsVitrina && outfitsVitrina.outfits.length > 0"
    :key="$route.name"
    class="container-carousel-categorys"
  >
    <div class="ps-4">
      <h2 class="title-carousel">
        {{ outfitsVitrina.titulo_vitrina }}
        {{ outfitsVitrina.subtitulo_vitrina }}
      </h2>
    </div>
    <carousel
      id="carousel-banner-category"
      :key="innerWidth"
      class="col-12 mx-0 position-relative carousel-products-content"
      :dots="true"
      :lazy-load="true"
      :nav="false"
      :responsive="{
        0: { items: 1, nav: false, stagePadding: 60 },
        704: { items: 2, nav: false, stagePadding: 60 },
        1030: { items: 3, nav: false, stagePadding: 50 },
        1200: { items: 3.6, nav: false, stagePadding: 30 },
      }"
    >
      <template slot="prev"
        ><span class="prev nav-button d-none d-md-block">
          <img
            src="@/assets/icons/left-carousel.svg"
            alt="left arrow carousel"
          /> </span
      ></template>
      <template slot="next"
        ><span class="next nav-button d-none d-md-block">
          <img
            src="@/assets/icons/right-carousel.svg"
            alt="right arrow carousel"
          /> </span
      ></template>
      <div
        v-for="(outfitVitrina, index) in outfitsVitrina.outfits"
        :key="index"
        class="item-category-home"
      >
        <router-link
          :to="{
            name: 'OutfitDetail',
            params: {
              category: outfitVitrina.campania_slug,
              id: outfitVitrina.slug,
              nameCreative: `home-${outfitVitrina.slug}`,
              slot: `Home-primary-outfits`,
              idCampaign: `${outfitVitrina.campania_slug}`,
              name: `${outfitVitrina.nombre}`,
            },
          }"
        >
          <div class="container-img-carousel-category">
            <img :src="outfitVitrina.img_portada" :alt="outfitVitrina.nombre" />
          </div>
          <div class="item-category">
            <p class="mb-0">
              {{ outfitVitrina.nombre }}
            </p>
          </div>
        </router-link>
      </div>
    </carousel>
    <div class="text-center">
      <a :href="outfitsVitrina.url">
        <button class="secondary-button">
          Ver todos los outfits
        </button>
      </a>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'

import carousel from 'v-owl-carousel'
export default {
  components: { carousel },
  computed: {
    ...mapState('layouts', ['outfitsVitrina']),
    ...mapState(['innerWidth']),
  },
  watch: {
    innerWidth() {
      this.validateDotsCarousel()
    },
  },
  methods: {
    ...mapActions('layouts', ['getCategorys']),
    validateDotsCarousel() {
      if (this.products) {
        setTimeout(() => {
          let element = document
            .getElementById('carousel-banner-category')
            .getElementsByClassName('owl-dot')
          element.forEach(e => {
            e.ariaLabel = 'Dot carousel'
            e.style.width =
              100 /
                (this.innerWidth >= 1048
                  ? parseInt(this.products.length / 2)
                  : this.products.length) +
              '%'
          })
        }, 100)
      }
    },
  },
}
</script>
